package fr.frux.shared.domain.model

import fr.frux.core.maps.Location

/**
 * Distance de l'arbre a [reference], en metres, ou null si aucune reference n'est connue.
 *
 * Le domaine ne porte volontairement aucune distance (#260) : le transport n'en renvoie pas pour
 * les arbres, et une valeur figee par la reponse serveur mentirait des que l'utilisateur bouge.
 * Toute surface qui affiche une distance la derive donc d'une reference explicite — position
 * reelle si connue, sinon centre interroge, jamais un repli invente.
 */
fun Tree.distanceMetersFrom(reference: Location?): Double? {
    val origin = reference ?: return null
    return Location(latitude, longitude).distanceMetersTo(origin)
}

/**
 * L'arbre demande une verification : identification declaree a confirmer, ou contestee par les
 * pairs (ADR 0015). Les deux causes se disent d'une seule voix — la carte ne distingue jamais
 * pourquoi, seulement qu'il faut regarder de plus pres.
 *
 * Regle metier du domaine plutot que du mapper : la carte, la bulle de selection et le filtre
 * « masquer les arbres a verifier » doivent tous s'accorder sur la meme definition.
 */
val Tree.needsCheck: Boolean
    get() = certainty == Certainty.TO_CONFIRM || disputed
